import { en, cs, de, es, nl, pt } from './localizations'

export const appStrings = { en, cs, de, es, nl, pt }

export * from './components/LocalizedRouter'
export * from './components/LocalizedSwitch'
